// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Recebimentos_SaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /recebimentos/save
 *
 * Creates or updates a recebimento. Returns the recebimento_id on success.
 * - If recebimento_id > 0: updates existing recebimento
 * - Otherwise: creates new recebimento
 *
 * The `dados` field is the integer recebimento_id (insertId for create,
 * affected row id for update) — preserved from the legacy primitive-dados
 * shape via a custom getDados() override.
 *
 * Failure paths use $this->sendError('...') in the controller; no
 * ResponseContract is needed for errors.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Recebimentos_SaveResponseDados = number;

export type Recebimentos_SaveResponse = ApiResponse<Recebimentos_SaveResponseDados>;

registerResponseContract('Recebimentos_SaveResponse', {})
